import React, { useContext, useEffect } from "react";
import { FoundersType, ResultContext } from "../ResultContext";
import { GivenQuestions } from "../constants/Questions";
import { LampSuggestion } from "../components/LampSuggestion";

export function CommitmentInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const currentQuestion = GivenQuestions.find((q) => q.id === questionId) as {
    dependsOn: number;
  };

  const dependsOn = currentQuestion.dependsOn as number;

  const dependsOnResult =
    (result[dependsOn] as {
      name: string;
      type: FoundersType;
    }[]) || [];

  const foundResult =
    (result[questionId] as { timeHours: string; timeWeeks: string }[]) ||
    Array.from({ length: dependsOnResult.length }, () => {
      return { timeHours: "40", timeWeeks: "44" };
    });

  if (dependsOnResult.length > foundResult.length) {
    const diff = dependsOnResult.length - foundResult.length;
    for (let i = 0; i < diff; i++) {
      foundResult.push({ timeHours: "38", timeWeeks: "44" });
    }
  }

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = Array.from({ length: dependsOnResult.length }, () => {
        return { timeHours: "38", timeWeeks: "44" };
      });

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  return (
    <div className="flex flex-column">
      {dependsOnResult.length === 1 && dependsOnResult[0].name === ""
        ? null
        : dependsOnResult.map((item, index) => {
            return (
              <div className={`${index !== 0 ? "mt-4" : ""}`} key={index}>
                <label>{item.name}</label>
                <div className="flex items-center">
                  <select
                    value={foundResult[index].timeHours}
                    onChange={(e) => {
                      const copy = { ...result };

                      copy[questionId] = foundResult.map((it, id) => {
                        if (id === index) {
                          return {
                            ...it,
                            timeHours: e.target.value,
                          };
                        }

                        return it;
                      });

                      setResult(copy);
                    }}
                  >
                    {Array.from(Array(100).keys()).map((item, index) => {
                      return (
                        <option value={item + 1} key={index}>
                          {item + 1}
                        </option>
                      );
                    })}
                  </select>
                  <div className="mr-3 ml-3">hours per week for</div>
                  <select
                    value={foundResult[index].timeWeeks}
                    onChange={(e) => {
                      const copy = { ...result };

                      copy[questionId] = foundResult.map((it, id) => {
                        if (id === index) {
                          return {
                            ...it,
                            timeWeeks: e.target.value,
                          };
                        }

                        return it;
                      });

                      setResult(copy);
                    }}
                  >
                    {Array.from(Array(52).keys()).map((item, index) => {
                      return (
                        <option value={item + 1} key={index}>
                          {item + 1}
                        </option>
                      );
                    })}
                  </select>
                  <div className="mr-3 ml-3">weeks per year.</div>
                </div>
              </div>
            );
          })}
      <LampSuggestion
        text={"Typically, a full-time equals 44 weeks & 40 hours per week."}
      />
    </div>
  );
}
